<template>
  <form @submit.prevent="submit">
    <slot :errors="errors" />
  </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AsyncForm",
  props: {
    action: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      errors: [],
    };
  },
  computed: {
    ...mapGetters({
      csrfToken: "getCsrfToken",
    }),
  },
  methods: {
    ...mapActions({ postAsync: "postAsync", fetchCsrfToken: "fetchCsrfToken" }),
    async submit(e) {
      await this.fetchCsrfToken();
      const formData = new FormData(e.target);
      formData.append("submit_button_name", e.submitter.name);
      formData.append("authenticity_token", this.csrfToken);
      this.postAsync({ path: `${this.action}.json`, formData })
        .then(() => e.target.reset())
        .catch(error => {
          this.errors = error.message;
        });
    },
  },
};
</script>
